import Alpine from 'alpinejs';
import Swiper, { Keyboard, Navigation, Autoplay, Pagination } from 'swiper';
import 'swiper/css/bundle';

Swiper.use([ Keyboard, Navigation, Autoplay, Pagination ]);

function randomString() {
    return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 10);
}

Alpine.data('swiper', () => {
    return {
        init() {

            const id = 'swiper-' + randomString();
            this.$refs['swiper'].id = id;

            this.swiper = new Swiper( this.$refs['swiper'], {
                speed: 400, 
                loop: true,
                loopedSlides: 1,
                slidesPerView: 1,
                allowTouchMove: true,
                // autoHeight: true,
                autoplay: {
                    delay: 3000,
                },
                navigation: {
                    nextEl: this.$refs['swiper'].querySelector('img'),
                },
                pagination: {
                    el: this.$refs['pagination'],
                },
            });
        },
        next(){
            this.swiper.slideNext();
        },
    }
});
